// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PLAN_QUALITY_PROVE_MODAL_CHANGE,
} from './constants';

export function qualityProveModalChange(visible) {
  return {
    type: PLAN_QUALITY_PROVE_MODAL_CHANGE,
    data:{visible}
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PLAN_QUALITY_PROVE_MODAL_CHANGE:
      return {
        ...state,
        qualityProveModalvisible:action.data.visible,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/plan/redux/qualityProveModalChange.js